// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1tCke","requiredAsterisk":"Info_requiredAsterisk__3qEPd"};